import { getEnv } from 'common-nextjs';

/**
 * TikTok Analytics script code without loading the actual script.
 * This sets up capturing events until the real script loads.
 *
 * See also: TikTokScript.tsx
 */
export function setupTikTokLocalCapture() {
  // @ts-ignore
  if (window.TiktokAnalyticsObject || window.ttq) return;

  const t = 'ttq';
  // @ts-ignore
  window.TiktokAnalyticsObject = t;
  // @ts-ignore
  // prettier-ignore
  const ttq = window[t] = window[t] || [];

  // @ts-ignore
  ttq.methods = [
    'page',
    'track',
    'identify',
    'instances',
    'debug',
    'on',
    'off',
    'once',
    'ready',
    'alias',
    'group',
    'enableCookie',
    'disableCookie',
  ];

  // @ts-ignore
  ttq.setAndDefer = function (t, e) {
    t[e] = function () {
      if (getEnv() !== 'production') {
        console.log(
          `[TikTok Local] ${e} called with args:`,
          Array.prototype.slice.call(arguments, 0),
        );
      }
      t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
    };
  };

  // @ts-ignore
  for (let i = 0; i < ttq.methods.length; i++) {
    // @ts-ignore
    ttq.setAndDefer(ttq, ttq.methods[i]);
  }

  // @ts-ignore
  ttq.instance = function (t) {
    // @ts-ignore
    const e = ttq._i[t] || [];
    // @ts-ignore
    for (let n = 0; n < ttq.methods.length; n++) {
      // @ts-ignore
      ttq.setAndDefer(e, ttq.methods[n]);
    }
    return e;
  };

  // @ts-ignore
  ttq.load = function (e, n) {
    const i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
    // @ts-ignore
    ttq._i = ttq._i || {};
    // @ts-ignore
    ttq._i[e] = [];
    // @ts-ignore
    ttq._i[e]._u = i;
    // @ts-ignore
    ttq._t = ttq._t || {};
    // @ts-ignore
    ttq._t[e] = +new Date();
    // @ts-ignore
    ttq._o = ttq._o || {};
    // @ts-ignore
    ttq._o[e] = n || {};
  };
}
